import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { privacyPolicyData as data } from "../data/candidate-explainer-privacy-policy.data";
import { useRedirectUrl } from "../hooks/useRedirectUrl";
import styles from "./candidate-explainer.module.scss";

export function CandidateExplainerPrivacyPolicy() {
  const redirect = useRedirectUrl();

  return (
    <div className={`${styles["candidateExplainer"]} candidate-container`}>
      <Helmet>
        <title>Sapia | Privacy Policy</title>
        <meta http-equiv="refresh" content="0; url=https://sapia.ai/privacy-policy-candidates/" />
      </Helmet>
      
      {/* <div className={styles["explainerBanner"]}>
        <ul className={styles["landingBreadcrumbs"]}>
          {data.header_section.breadcrums.map((b, i) => {
            switch (i) {
              case 0:
                return (
                  <li className={styles["candidateBtn"]} key={i}>
                    <a href={redirect}>{b.label}</a>
                  </li>
                );
              default:
                return (
                  <li key={i}>
                    <Link to="/candidate-explainer">
                      FirstInterview Explainer
                    </Link>
                  </li>
                );
            }
          })}
        </ul>
      </div>

      {data.main_section.map((s, i) => {
        switch (s.section_type) {
          case "1":
            return (
              <div className="first-interview" key={i}>
                <div className="container">
                  <div className="explainer-seprator">
                    <div
                      dangerouslySetInnerHTML={{ __html: s.section_content }}
                    />
                  </div>
                </div>
              </div>
            );
        }
      })}

      <div className="this-page-section">
        <div className="container">
          <h2>
            <strong>Candidate Privacy Policy</strong>
          </h2>
          <h3>Welcome!</h3>
          <p>
            <strong>
              We have two Privacy Policies, to clearly set out the different
              ways that we collect, manage, use and disclose the information of:
            </strong>
          </p>
          <ol>
            <li>
              <strong>
                our clients, prospects and individuals who contact us directly;
                and
              </strong>
            </li>
            <li>
              <strong>candidates who apply for roles with our clients.</strong>
            </li>
          </ol>
          <p></p>
          <p>
            <strong>
              This Privacy Policy applies to you if you are a candidate applying
              for a job with one of our clients who use our interview platform.
              If you are a client of ours (an employer), please review our
              client-specific{" "}
              <a
                target="__blank"
                href="https://www.predictivehire.com/privacy-policy/"
              >
                Privacy Policy
              </a>
              .
            </strong>
          </p>
          <p></p>
          <p>
            For candidates who interact with us using our interview platform
            only, we act as a ‘processor’ of your personal data. The
            organisation where you’ve applied for a job will remain the
            ‘controller’ of your personal data. If you have any questions about
            how that organisation uses your personal data, we recommend you
            contact them directly to find out more.
          </p>
          <p></p>
          <p>
            Though if you have any questions for us, of course we’ll do our best
            to help. If you reach out to us directly for support, we’ll also
            become a data ‘controller’ and you should take note of our
            client-specific{" "}
            <a
              target="__blank"
              href="https://www.predictivehire.com/privacy-policy/"
            >
              Privacy Policy
            </a>
            , which will apply to our provision of support to you.
          </p>

          <p></p>
          <h3>Who are you?</h3>
          <p>
            Sapia Pty Ltd (“Sapia”, “we”, “our”, or “us”) is a
            software provider, who offer talent intelligence software to our
            clients. Our clients have chosen us to provide you with an online
            interview or questionnaire. Using our artificial intelligence
            solution, we derive patterns from your free-text answers collected
            during the interview process.
          </p>
          <p></p>
          <p>
            Rather than just matching keywords, our technology reads, deciphers,
            understands, and makes sense of answers. In addition, we may process
            video responses and/or demographic information on behalf of our
            clients. We’ll refer to this technology as our “Platform” throughout
            the rest of this Privacy Policy. You can find out more about our
            Platform{" "}
            <a
              href="https://me.predictivehire.com/candidate-explainer"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
            .
          </p>
          <p>
            We are committed to protecting your privacy. If you have any
            questions about this Privacy Policy, please contact us at{" "}
            <a href="mailto:privacy@predictivehire.com">
              privacy@predictivehire.com
            </a>{" "}
            or write to us by mail at PO Box 1405, St Kilda South, Melbourne,
            3182 Victoria, Australia.
          </p>
          <p>
            If you are a United Kingdom (UK) or European Economic Area (EEA)
            resident, our representative for data protection queries is
            Prighter, whose details are available{" "}
            <a
              href="https://prighter.com/q/14328687263"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
            .
          </p>

          <h3>What personal data do you need?</h3>

          <p>
            When you apply for a job with one of our clients, we need to collect
            your personal data so our client can offer you an online interview.
            You might give this information to us directly, or our client may
            provide it. The data we collect will include your full name, email
            address, phone number, location, IP address, browser information and
            any other information requested on the application that the
            organisation you are applying to has asked us to collect.{" "}
          </p>

          <p>
            When you complete your online interview or questionnaire, we’ll
            collect your answers and make these available to the organisation
            where you are applying. In some cases, we may also collect video
            responses.
          </p>

          <p>
            In simple terms, your personal data is used to identify you in our
            Platform (so the organisation knows who you are). If your personal
            data is not collected, our clients will be unable to assess your
            suitability for available roles properly.
          </p>

          <p>
            We may also use anonymised personal data for testing our Artificial
            Intelligence (AI). This data ensures that candidates are not
            disadvantaged during the interview regardless of their gender,
            ethnicity, age, or other protected characteristics. However, we
            promise that we never use your personal data in our AI algorithms.
            Hence, it has no impact on assessing your suitability for a role.
          </p>

          <p>
            To help us develop our Platform and serve you better, we will also
            collect information using third party services. These third parties
            may include but are not limited to,{" "}
            <a
              href="https://www.intercom.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Intercom
            </a>{" "}
            and{" "}
            <a
              href="https://www.hotjar.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Hotjar
            </a>
            . Data collected may include your IP address, browser details and
            operating system. We may also collect information about how and when
            you interact with the Platform (e.g., where you click, scroll your
            mouse, move in between pages). In this case, we never collect
            sensitive information such as email addresses, credit card details
            or passwords. Our{" "}
            <a
              href="https://www.predictivehire.com/cookie-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Cookie Policy
            </a>{" "}
            provides more detail on the information we collect. We will never
            sell your personal data to any third party.
          </p>

          <h3>What about my sensitive information?</h3>
          <p>
            When completing an interview through Sapia, we may ask
            questions about your health status, background, racial or ethnic
            origin, or other genetic information. The personal data we request
            will differ between our clients, and answering is generally
            optional.{" "}
          </p>

          <p>
            If you choose to answer the questions, you consent to our
            collection, use and disclosure of your sensitive personal data as
            described in this Privacy Policy and as permitted by law.{" "}
          </p>

          <p>
            Our clients may use the personal data we collect to understand
            better the diversity of their candidates’ and their employees, but
            only at a general level. They can only view the overall data and not
            your data specifically. Your personal data is anonymised once
            collected and before being shared with any of our sub-processors or
            disclosed outside your region (more on this below).{" "}
          </p>

          <p>
            We may use your anonymised personal data to test our AI to make sure
            we are not discriminating against candidates.
          </p>

          <h3>What do you do with my personal data?</h3>
          <p>
            We process the personal data we collect and share it with certain
            sub-processors on our behalf to evaluate your capabilities. As a
            result, we generate a personality and behavioural profile that our
            client can then utilise to make hiring decisions and coach and
            improve performance once employed.{" "}
          </p>

          <p>
            As mentioned above, we also process your anonymised personal data to
            improve our Platform through machine learning and testing for
            adverse impact. In addition, we use behavioural information to
            improve our Platform and provide you with a better experience.
          </p>

          <h3>Do you share my personal data with anyone?</h3>
          <p>
            It might sound obvious, but we will pass your interview responses to
            our clients when you apply for a job with them. We are not
            responsible for how they then use or process your personal data. You
            should review their applicable privacy policy for information on how
            they use your personal data.{" "}
          </p>

          <p>
            Like most organisations, we may share your data with several
            third-party services and tools to run our Platform. These are known
            as sub-processors. Think about it. Suppose you were applying for a
            loan from a bank. In that case, they would likely need to share your
            personal data with credit reference agencies before they make a
            lending decision. In our case, we use sub-processors to help provide
            us computing power, communicate with you and analyse your data. By
            disclosing your personal data, including sensitive information to us
            on the Platform, you consent to this information being provided to
            third parties to run the Platform and provide services to you and
            our clients. These third parties may include parties based in the
            United States of America. Ask us for more details.
          </p>

          <p>
            We might also need to share your personal data with relevant
            authorities or organisations if we are under a duty to disclose or
            share your personal data to comply with any legal obligation, or to
            enforce or apply our terms of use and other agreements; or to
            protect the rights, property, or safety of our clients or others. We
            may exchange information with other companies and organisations for
            fraud protection.
          </p>

          <p>
            We may also share personal data with prospective buyers of our
            business under our legitimate interest to ensure the buyer can
            continue our business.
          </p>

          <h3>Do you transfer personal data internationally?</h3>
          <p>
            {" "}
            We store and process the data we collect from you in the same
            geographic region of our client (the company you are applying to
            work with). For example, suppose you live in Australia but apply to
            work with an American organisation. In that case, your data will
            likely be stored and processed in the USA.{" "}
          </p>

          <p>
            Sapia is a global organisation with clients and employees
            across the world. To provide you with our services, we need to
            transfer personal data between our teams for the purposes described
            in this Privacy Policy. This Privacy Policy continues to apply even
            when we transfer personal data outside of your country of residence.{" "}
          </p>

          <p>
            Whenever we transfer your personal data outside of the UK and the
            EU, we ensure it receives additional protection as required by law.
            We haven’t set out these specific circumstances to keep this Privacy
            Policy as short and easy to understand as possible. However, you can
            contact us for more information.
          </p>

          <h3>How long will you keep my personal data?</h3>
          <p>
            As a data ‘processor’, we will retain your personal data for a
            period set by our client (the ‘controller’). You should review their
            applicable privacy policy for information on how they use your
            personal data and how long they store it.{" "}
          </p>

          <p>
            If our client does not define a retention policy, we will retain
            your personal data for as long as they remain a client of
            Sapia unless they (or you) ask us to delete it. If you ask
            us to delete your personal data, we will either permanently
            de-identify or delete it unless we require it for legal reasons.
          </p>

          <p>
            In some circumstances, we carefully anonymise your personal data so
            that it can no longer be associated with you, and we may use this
            anonymised information indefinitely without notifying you. We use
            this to test our AI solution for any adverse impact.
          </p>

          <h3>How do I access or control the personal data you have? </h3>
          <p>
            You have various rights under applicable data protection and privacy
            laws, including the right to:
          </p>
          <ul className="this-page-list">
            <li>
              <strong>access</strong> your personal data (also known as a
              “subject access request”);
            </li>
            <li>
              <b>correct</b> incomplete or inaccurate data we hold about you;
            </li>
            <li>
              ask us to <b>erase</b> the personal data we hold about you;
            </li>
            <li>
              ask us to <b>restrict</b> our handling of your personal data;
            </li>
            <li>
              ask us to <b>transfer</b> your personal data to a third party;{" "}
            </li>
            <li>
              <b>object</b> to how we are using your personal data; and
            </li>
            <li>
              <b>withdraw</b> your consent to us handling your personal data.
            </li>
          </ul>

          <p></p>
          <p>
            <strong>
              {" "}
              To exercise any of your data privacy rights, you should contact
              the organisation you’ve applied for a role with in the first
              instance.
            </strong>
            However, if you wish to contact us (
            <a href="mailto:privacy@predictivehire.com">
              privacy@predictivehire.com
            </a>
            ), we will do our best to help you.
          </p>
          <p>
            You also have the right to complain about us collecting and using
            your personal data with your relevant supervisory authority. Contact
            details are freely available, but we have included links to some
            common supervisory authorities below: <br />
            <a
              href="https://www.oaic.gov.au/about-us/contact-us/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Australia
            </a>{" "}
            <br />
            <a
              href="https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm"
              target="_blank"
              rel="noopener noreferrer"
            >
              European Union
            </a>{" "}
            <br />
            <a
              href="https://ico.org.uk/global/contact-us/"
              target="_blank"
              rel="noopener noreferrer"
            >
              United Kingdom
            </a>{" "}
          </p>
          <h3>What if I have any questions?</h3>
          <p>
            We’ve worked hard to create a Privacy Policy that’s easy to read and
            clear. However, if you would like any more information, please
            contact our Data Protection Officer at{" "}
            <a href="mailto:privacy@predictivehire.com">
              privacy@predictivehire.com
            </a>
            . You can also reach us by mail at PO Box 1405, St Kilda South,
            Melbourne, 3182 Victoria, Australia.{" "}
          </p>

          <p>
            If you are a United Kingdom (UK) or European Economic Area (EEA)
            resident, our representative for data protection queries is
            Prighter, whose contact details are available{" "}
            <a
              href="https://prighter.com/q/14328687263"
              target="_blank"
              rel="noopener noreferrer"
            >here</a>
            .
          </p>

          <div className="candidate-inner-padding"></div>
        </div>
      </div>

      <div className="interview-support-section explainer-padding">
        <div className="container">
          <div className="text-center">
            <h3 className="blue-title">{data.contact_section.section_title}</h3>
            <button
              type="button"
              className="btn-help"
              style={{ cursor: "pointer" }}
            >
              {data.contact_section.button_label}
            </button>
            <p>
              <a
                href={data.contact_section.privacy_button_link}
                className="black-link"
              >
                {data.contact_section.privacy_button_label}
              </a>
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
}
